import Vue from 'vue'

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('date', (value) => {
  if (!value) return ''
  const parseDate = new Date(value)
  const locale = 'pl-PL'
  return `${parseDate.toLocaleTimeString(locale).slice(0, 5)} ${('0' + parseDate.toLocaleDateString(locale)
                                                                .replace(/\./g, '-')).slice(-10)}`
})

Vue.filter('currency', (value, precision = 0) => {
  value = Number(value)
  if (isNaN(value)) return ''
  return value.toFixed(precision).replace(/(\d)(?=(\d{3}))/g, '$1 ').replace(/\./g, ',') + ' zł'
})

Vue.filter('valToName', (value, collection) => {
  if (!value || !collection) return ''
  return collection.find((item) => {
    return item.value === value
  }).name
})



// WEBPACK FOOTER //
// ./src/filters/index.js